import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	summarizeInChatButtonText: {
		id: 'summarize-in-chat-button-text',
		defaultMessage: 'Summarize',
		description: 'Text for the button that summarizes the page in chat',
	},
});
